import { combineReducers } from 'core/redux'

import attachments from '../attachments'
import customProfile from '../customProfile'
import emailMarketing from '../emailMarketing'
import github from '../github'
import jiraCloud from '../jiraCloud'
import jiraServer from '../jiraServer'
import trello from '../trello'
import credentials from './credentials'
import hubspot from '../hubspot/reducers'
import recentConversations from '../recentConversations/reducers'
import salesforce from '../salesforce/reducers'
import shopify from '../shopify'
import slack from '../slack'
import recharge from '../recharge/reducers'
import stripe from '../stripe/reducers'

export default combineReducers({
  attachments,
  credentials,
  emailMarketing,
  recentConversations,
  thirdPartyData: combineReducers({
    customProfile,
    github,
    jiraCloud,
    jiraServer,
    trello,
    hubspot,
    salesforce,
    shopify,
    slack,
    recharge,
    stripe,
  }),
})
